var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiNeutralFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 40.0002C11.018 40.0002 0.248779 33.7391 0.248779 20.0002C0.248779 6.26142 11.018 0.000244141 21.0001 0.000244141C26.5457 0.000244141 31.662 1.82493 35.4545 5.1523C39.569 8.80167 41.7515 13.9537 41.7515 20.0002C41.7515 26.0468 39.569 31.163 35.4545 34.8124C31.662 38.1398 26.51 40.0002 21.0001 40.0002Z",
    fill: "url(#paint0_radial_390_2455)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1343 8.11157C40.0413 11.1885 41.0359 14.8522 41.0359 18.9273C41.0359 24.9738 38.8534 30.0901 34.7389 33.7395C30.9464 37.0669 25.7944 38.9273 20.2846 38.9273C13.823 38.9273 7.04663 36.2976 3.04663 30.7198C6.89636 37.0382 14.1379 40.0007 21.0001 40.0007C26.51 40.0007 31.662 38.1402 35.4545 34.8128C39.569 31.1635 41.7515 26.0472 41.7515 20.0007C41.7515 15.4425 40.51 11.3924 38.1343 8.11157Z",
    fill: "#EB8F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.088 28.9816H12.1989C11.4083 28.9816 10.7678 28.3412 10.7678 27.5505C10.7678 26.7598 11.4083 26.1194 12.1989 26.1194H30.088C30.8787 26.1194 31.5192 26.7598 31.5192 27.5505C31.5192 28.3412 30.8787 28.9816 30.088 28.9816Z",
    fill: "#422B0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2272 13.9319C12.7281 13.9319 11.365 15.1984 11.365 17.3022C11.365 19.4059 12.7281 20.6689 14.2272 20.6689C15.7263 20.6689 17.0895 19.4024 17.0895 17.3022C17.0895 15.202 15.7263 13.9319 14.2272 13.9319Z",
    fill: "#422B0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0878 15.3388C13.5797 15.0955 12.9679 15.3102 12.7211 15.8182C12.5314 16.2154 12.6173 16.6912 12.9357 16.9989C13.4438 17.2422 14.0556 17.0275 14.3024 16.5195C14.4921 16.1223 14.4062 15.6465 14.0878 15.3388Z",
    fill: "#896024"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9411 13.9319C26.442 13.9319 25.0789 15.1984 25.0789 17.3022C25.0789 19.4059 26.442 20.6689 27.9411 20.6689C29.4402 20.6689 30.8034 19.4024 30.8034 17.3022C30.8034 15.202 29.4474 13.9319 27.9411 13.9319Z",
    fill: "#422B0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8085 15.3388C27.3004 15.0955 26.6886 15.3102 26.4418 15.8182C26.2521 16.2154 26.338 16.6912 26.6564 16.9989C27.1645 17.2422 27.7763 17.0275 28.0232 16.5195C28.2128 16.1223 28.1269 15.6465 27.8085 15.3388Z",
    fill: "#896024"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_390_2455",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0001 20.0002) scale(20.3791 20.3791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiNeutralFace);
export default __webpack_public_path__ + "static/media/emoji-neutral-face.2212915cc749209640af803de221509a.svg";
export { ForwardRef as ReactComponent };